const copy_link_ready = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};


copy_link_ready(() => {
   document.querySelectorAll(".js-copy-link").forEach(function (button) {
      button.addEventListener("click", function (event) {
         event.preventDefault();
         const url = this.getAttribute("data-url");

         navigator.clipboard.writeText(url).then(() => {
            alert("The link has been copied!");
         }).catch(err => {
            console.error("Copy Error: ", err);
         });
      });
   });
});
